import { ArrowRightLeft, FileText, MessageSquare, Pencil, PlusCircle, Receipt, Wallet, CheckCircle2, Trash2 } from "lucide-react";
import { fmtDateTime } from "@/lib/constants";
import { Card, EmptyState } from "@/components/shared";

const ICONS = {
  status_changed: [ArrowRightLeft, "bg-indigo-100 text-indigo-700"],
  note: [MessageSquare, "bg-teal-100 text-teal-700"],
  project_created: [PlusCircle, "bg-slate-100 text-slate-700"],
  project_updated: [Pencil, "bg-slate-100 text-slate-600"],
  document_uploaded: [FileText, "bg-sky-100 text-sky-700"],
  document_removed: [Trash2, "bg-rose-100 text-rose-700"],
  proposal_accepted: [CheckCircle2, "bg-emerald-100 text-emerald-700"],
  invoice_created: [Receipt, "bg-amber-100 text-amber-700"],
  invoice_updated: [Receipt, "bg-amber-100 text-amber-700"],
  payment_received: [Wallet, "bg-emerald-100 text-emerald-700"],
};

export const ActivityTab = ({ activities }) => (
  <Card title="Activity" testid="activity-tab">
    {activities.length === 0 ? <EmptyState title="No activity recorded yet" /> : (
      <ol className="relative border-l border-slate-200 ml-3 space-y-4">
        {activities.map((a) => {
          const [Icon, cls] = ICONS[a.type] || ICONS.project_updated;
          return (
            <li key={a.id} className="ml-6" data-testid={`activity-item-${a.type}`}>
              <span className={`absolute -left-3 flex h-6 w-6 items-center justify-center rounded-full ${cls}`}><Icon className="h-3.5 w-3.5" /></span>
              <div className="text-sm text-slate-800 leading-snug pt-0.5">{a.message}</div>
              <div className="text-xs text-slate-500 mt-0.5">{a.user_name} · {fmtDateTime(a.created_at)}</div>
            </li>
          );
        })}
      </ol>
    )}
  </Card>
);
